import React from "react";
import { Card } from "antd";
import "./styles.css";
import { REFUSED } from "dns";
const { Meta } = Card;

interface cat {
    category : {name:string, img:string}
}


const CategoriesSideBar: React.FC<cat>= ({category}) => {


  return (
    <Card  className="productShop" cover={<img src={category.img}  alt="example" />}>
      <Meta className="meta"
        title ={category.name}
      />
    </Card>
  );
};

export default CategoriesSideBar;
